import {
  ConvertHeicToJpegMutationVariables,
  ConvertHeicToJpegResult,
  convertHeicToJpeg,
  getSanitizedFile,
  getTempFileKeyForConvertion,
} from '@rentguru/commons-utils';
import { mutation } from '@up2rent/graphql';
import isNil from 'lodash/isNil';

import { downloadData, uploadData } from 'src/auth/storage';

export const handleNewHEICFile = async (file: File, clientId: string | null) => {
  if (isNil(clientId)) {
    console.error('Cannot convert a HEIC file without a client id');
    return null;
  }
  const heicFile = getSanitizedFile(file);

  const fileKey = getTempFileKeyForConvertion(clientId, heicFile.name);
  await uploadData({
    key: `public/${fileKey}`,
    data: await heicFile.arrayBuffer(),
    options: {
      contentDisposition: `attachment; filename="${heicFile.name}"`,
    },
  }).result;

  try {
    const response = await mutation<ConvertHeicToJpegResult, ConvertHeicToJpegMutationVariables>(convertHeicToJpeg, {
      input: {
        s3FileKey: `public/${fileKey}`,
      },
    });

    const convertedFileKey = response?.fileKey;
    if (!convertedFileKey) {
      throw new Error('HEIC conversion returned no fileKey');
    }

    const { body: storageBody } = await downloadData({ key: convertedFileKey }).result;
    const convertedBlob = await storageBody.blob();

    return convertedBlob;
  } catch (err) {
    console.error('error in convertor', err);
    return null;
  }
};
